module.exports = __webpack_public_path__ + "media/images/bg_seminar_mv_sp-60424926a5abd0e12d5a3086348890ff.jpg";